import * as types from './types';
import * as _ from 'lodash';
import { formatHistoryDataDates } from '../../helpers/Helpers';

const INITIAL_STATE = {
  historyData: [],
  appData: {},
  fetchError: {},
  fetching: false,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.APPLICATION_HISTORY_FETCH_ERROR:
      if (_.has(payload, 'response.data.Errors')) {
        const fetchError = payload.response.data.Errors[0];

        return {
          ...state,
          fetchError,
        };
      }
      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message:
            'An error occurred while fetching this application. Please try again.',
        },
      };
    case types.APPLICATION_HISTORY_FETCHING:
      return {
        ...state,
        fetching: payload,
      };
    case types.APPLICATION_HISTORY_FETCH_APP_DATA:
      return {
        ...state,
        appData: payload,
      };
    case types.APPLICATION_HISTORY_FETCH_DATA:
      return {
        ...state,
        historyData: formatHistoryDataDates(payload),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/applicationhistory/reducer.js